import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { useMemo } from 'react'
import { Config, ConfigResponse, Theme } from '../types'

const GET_CONFIG = gql`
    query GetConfig($domain: String!) {
        pages(filters: { domain: { eq: $domain } }) {
            domain
            name
            spotify
            tiktok
            youtube
            instagram
            theme
            producer
            shopify_collection
        }
    }
`

const defaultTheme: Theme = {
    background: '#070b15',
    text: '#f5f7ff',
    secondaryText: '#adb4c9',
    border: '#2b3247',
    buttonBackground: '#1a2237',
    buttonText: '#f5f7ff',
    hoverBackground: '#2a3553',
    cardBackground: '#101726',
    buttonHoverText: '#ffffff',
    buttonHoverBackground: '#3a4a74',
}

export const useConfig = (domain: string) => {
    const { data, loading, error } = useQuery<ConfigResponse>(GET_CONFIG, {
        variables: { domain },
    })

    const fallbackConfig: Config = {
        id: 0,
        documentId: 'fallback',
        domain,
        name: 'GSSNHR Records',
        createdAt: '',
        updatedAt: '',
        publishedAt: '',
        spotify: null,
        tiktok: null,
        youtube: null,
        instagram: null,
        theme: defaultTheme,
        producer: false,
        shopify_collection: '',
    }

    const config = data?.pages[0] || (error ? fallbackConfig : null)

    const theme: Theme = useMemo(() => {
        return {
            ...defaultTheme,
            ...(config?.theme || {}),
        }
    }, [config])

    return { config, theme, loading, error }
}
